import { useQuery } from "react-query";
import axios from "../utils/axios-util";

const fetchUserName = () => {
  return axios({ url: "/user", method: "get" });
};

const useUserData = () => {
  return useQuery("userData", () => fetchUserName());
};

export default useUserData;
